import type { isArray_F } from './types';

export const isArray: isArray_F = value => Array.isArray(value);
